"use client";

import {
  ArrowExpand01Icon,
  ArrowLeft03Icon,
} from "@hugeicons-pro/core-stroke-rounded";
import ControlIcon from "./ControlIcon";
import { ControlContainer, type ControlProps } from "./IconContainer";

type Props = ControlProps & { isExpanded?: boolean };

export function GameControlsExpand({ isExpanded, ...props }: Props) {
  return (
    <ControlContainer {...props}>
      <ControlIcon icon={isExpanded ? ArrowLeft03Icon : ArrowExpand01Icon} />
    </ControlContainer>
  );
}
